(() => {
  class GobRecentlyViewed {
    constructor(container) {
      this.container = container;
      if (container.dataset.gobRecentInitialized) return;
      container.dataset.gobRecentInitialized = 'true';
      this.controller = new AbortController();
      this.init();
    }

    async init() {
      const container = this.container;
      const output = container.querySelector('[id^="RecentlyViewed-"]');
      const current = String(container.dataset.productId);
      const maximum = Math.max(0, Number.parseInt(container.dataset.maxProducts, 10) || 0);
      const history = Array.isArray(window.theme.recentlyViewedIds) ? window.theme.recentlyViewedIds : [];
      const ids = [...new Set(history.map(String))].filter(id => /^\d+$/.test(id) && id !== current).slice(0, maximum);
      container.hidden = true;
      if (!output || !ids.length) {
        container.dataset.gobRecentState = 'empty';
        return;
      }
      container.dataset.gobRecentState = 'loading';
      const query = ids.map(id => 'id:' + id).join(' OR ');
      const url = window.theme.routes.search + '?view=recently-viewed&type=product&q=' + encodeURIComponent(query);
      try {
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Recently viewed request failed: ' + response.status);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = document.querySelector('.product-grid');
        if (!grid || !grid.querySelector('.grid-product')) {
          container.dataset.gobRecentState = 'empty';
          return;
        }
        if (!container.isConnected) return;
        output.replaceChildren(grid);
        new window.theme.QuickAdd(output);
        new window.theme.QuickShop(output);
        const footer = window.document.querySelector('.gobft');
        const footerRect = footer?.getBoundingClientRect();
        const preserveFooter = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
        container.classList.remove('hide');
        container.dataset.gobRecentState = 'ready';
        container.hidden = false;
        if (window.AOS) window.AOS.refreshHard();
        if (preserveFooter) {
          const offset = footer.getBoundingClientRect().top - footerRect.top;
          if (Math.abs(offset) > 0.5) window.scrollBy({top: offset, left: 0, behavior: 'instant'});
        }
        container.dispatchEvent(new CustomEvent('gob:recently-viewed:loaded', {bubbles: true}));
      } catch (error) {
        if (error.name === 'AbortError') return;
        container.hidden = true;
        container.dataset.gobRecentState = 'unavailable';
        console.error(error);
      }
    }

    onUnload() {
      this.controller?.abort();
      delete this.container.dataset.gobRecentInitialized;
    }
  }

  function register() {
    const sections = window.theme?.sections;
    if (!sections || sections.constructors['gob-recently-viewed']) return;
    sections.register('gob-recently-viewed', GobRecentlyViewed);
  }

  if (window.theme?.sections) register();
  else document.addEventListener('DOMContentLoaded', register, {once: true});
})();
